<template>
  <!--<div class="vue-image-crop-upload" v-show="value">-->
  <!---->
  <!--</div>-->
  <el-dialog
    :close-on-click-modal="false"
    class="vue-image-crop-upload"
    :visible.sync="cp_value"
    top="calc(50vh - 210px)"
    width="610px"
    @close="off"
  >
    <div
      slot="title"
      class="dialog-title"
    >
      <span>{{ title }}</span>
    </div>
    <div class="vicp-wrap">
      <div
        v-show="step == 1"
        class="vicp-step1"
      >
        <div
          class="vicp-drop-area"
          @dragleave="preventDefault"
          @dragover="preventDefault"
          @dragenter="preventDefault"
          @click="handleClick"
          @drop="handleChange"
        >
          <i
            v-show="loading != 1"
            class="vicp-icon1"
          >
            <i class="vicp-icon1-arrow" />
            <i class="vicp-icon1-body" />
            <i class="vicp-icon1-bottom" />
          </i>
          <span
            v-show="loading !== 1"
            class="vicp-hint"
          >{{ lang.hint }}</span>
          <span
            v-show="!isSupported"
            class="vicp-no-supported-hint"
          >{{ lang.noSupported }}</span>
          <input
            v-show="false"
            v-if="step == 1"
            ref="fileinput"
            type="file"
            accept="image/png,image/jpeg"
            @change="handleChange"
          >
        </div>
        <div
          v-show="hasError"
          class="vicp-error"
        >
          <i class="vicp-icon2" /> {{ errorMsg }}
        </div>
        <div class="vicp-operate">
          <el-button
            class="btn-plain"
            size="small"
            @click="off"
          >
            {{ lang.btn.off }}
          </el-button>
          <!--<a @click="off" @mousedown="ripple">{{ lang.btn.off }}</a>-->
        </div>
      </div>

      <div
        v-if="step == 2"
        class="vicp-step2"
      >
        <div class="vicp-crop">
          <div
            v-show="true"
            class="vicp-crop-left"
          >
            <span class="vicp-title">LOGO上传</span>
            <div class="vicp-img-container">
              <img
                ref="img"
                :src="sourceImgUrl"
                :style="sourceImgStyle"
                class="vicp-img"
                draggable="false"
                @drag="preventDefault"
                @dragstart="preventDefault"
                @dragend="preventDefault"
                @dragleave="preventDefault"
                @dragover="preventDefault"
                @dragenter="preventDefault"
                @drop="preventDefault"
                @touchstart="imgStartMove"
                @touchmove="imgMove"
                @touchend="createImg"
                @touchcancel="createImg"
                @mousedown="imgStartMove"
                @mousemove="imgMove"
                @mouseup="createImg"
                @mouseout="createImg"
              >
              <div
                class="vicp-img-shade vicp-img-shade-1"
                :style="sourceImgShadeStyle"
              />
              <div
                class="vicp-img-shade vicp-img-shade-2"
                :style="sourceImgShadeStyle"
              />
            </div>

            <div class="vicp-range clear-fix">
              <img
                class="fl"
                src="../../../assets/crop-image/icon_minus.png"
                @mousedown="startZoomSub"
                @mouseout="endZoomSub"
                @mouseup="endZoomSub"
              >
              <el-slider
                v-model="scale.range"
                class="fl crop-slider"
                :show-tooltip="false"
                @change="zoomChange"
              />
              <img
                class="fr"
                src="../../../assets/crop-image/icon-plus.png"
                @mousedown="startZoomAdd"
                @mouseout="endZoomAdd"
                @mouseup="endZoomAdd"
              >
              <!--<input type="range" :value="scale.range" step="1" min="0" max="100" @mousemove="zoomChange">-->
              <!--<i @mousedown="startZoomSub" @mouseout="endZoomSub" @mouseup="endZoomSub" class="vicp-icon5"></i>-->
              <!--<i @mousedown="startZoomAdd" @mouseout="endZoomAdd" @mouseup="endZoomAdd" class="vicp-icon6"></i>-->
            </div>

            <div
              v-if="!noRotate"
              class="vicp-rotate"
            >
              <i @click="rotateImg">↻</i>
            </div>
          </div>
          <div
            v-show="true"
            class="vicp-crop-right"
          >
            <div class="vicp-preview">
              <div
                v-if="!noSquare"
                class="vicp-preview-item"
              >
                <img
                  :src="createImgUrl"
                  :style="previewStyle"
                >
                <span>LOGO预览</span>
              </div>
              <div
                v-if="!noCircle"
                class="vicp-preview-item vicp-preview-item-circle"
              >
                <img
                  :src="createImgUrl"
                  :style="previewStyle"
                >
                <span>LOGO预览</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vicp-operate">
          <el-button
            class="btn-plain"
            size="small"
            @click="setStep(1)"
          >
            {{ lang.btn.off }}
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="prepareUpload"
          >
            {{ lang.btn.save }}
          </el-button>
          <!--<a @click="setStep(1)" @mousedown="ripple">{{ lang.btn.back }}</a>-->
          <!--<a class="vicp-operate-btn" @click="prepareUpload" @mousedown="ripple">{{ lang.btn.save }}</a>-->
        </div>
      </div>

      <div
        v-if="step === 3"
        class="vicp-step3"
      >
        <div class="vicp-upload">
          <span
            v-show="loading === 1"
            class="vicp-loading"
          >{{ lang.loading }}</span>
          <div class="vicp-progress-wrap">
            <span
              v-show="loading === 1"
              class="vicp-progress"
              :style="progressStyle"
            />
          </div>
          <div
            v-show="hasError"
            class="vicp-error"
          >
            <i class="vicp-icon2" /> {{ errorMsg }}
          </div>
          <div
            v-show="loading === 2"
            class="vicp-success"
          >
            <i class="vicp-icon3" /> {{ lang.success }}
          </div>
        </div>
        <div class="vicp-operate">
          <a
            @click="setStep(2)"
            @mousedown="ripple"
          >{{ lang.btn.back }}</a>
          <a
            @click="off"
            @mousedown="ripple"
          >{{ lang.btn.close }}</a>
        </div>
      </div>
      <canvas
        v-show="false"
        ref="canvas"
        :width="width"
        :height="height"
      />
    </div>
  </el-dialog>
</template>

<script>
// import "@/assets/plugin/browser-md5-file.min.js";
import cropImage from 'vue-image-crop-upload';

export default {
    name: 'UploadAvatar',
    extends: cropImage,
    props: {
        title: {
            type: String,
            default: '上传图片',
        },
        // 单文件大小限制
        maxSize: {
            type: Number,
            default: 1024,
        },
    },
    data () {
        return {
        };
    },

    computed: {
        cp_value: {
            get () {
                return this.value;
            },
            set (v) {
                this.$emit('input', v);
            },
        },
    },

    mounted () {
        document.body.appendChild(this.$el);
    },

    destroyed () {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    },
    methods: {
        prepareUpload () {
            let self = this,
                {
                    createImgUrl,
                    field,
                    ki,
                } = self;
            this.$emit('crop-success', createImgUrl, field, ki);
        },
        // 关闭控件
        off () {
            this.$emit('input', false);
            this.setStep(1);
        },
        zoomChange (e) {
            this.zoomImg(e);
        },
        handleChange (e) {
            e.preventDefault();
            let files = e.target.files || e.dataTransfer.files;
            if (this.loading !== 1 && files.length > 0) {
                this.reset();
                if (this.checkFile(files[0])) {
                    this.setSourceImg(files[0]);
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
  @import "../../../sass/theme.scss";
  .vue-image-crop-upload {
    background: transparent;
    .vicp-wrap {
      position: relative;
      box-shadow: none;
      width: 100%;
      height: 270px;
      padding: 0;
      margin-top: -20px;
      .vicp-operate {
        bottom: 0;
      }
      .vicp-step1 {
        padding-top: 10px;
        display: flex;
        justify-content: space-around;
        .vicp-drop-area {
          width: 220px;
          height: 200px;
          padding: 50px 0;
        }
      }
      .vicp-step2 .vicp-crop .vicp-crop-left {
        position: relative;
        .vicp-range {
          height: 21px;
        }
      }
      .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {
        overflow: visible;
        .vicp-preview-item {
          margin-right: 45px;
          &.vicp-preview-item-circle {
            margin-right: 15px;
          }
          span {
            bottom: auto;
            top: -25px;
            font-size: 14px;
            color: $font-c;
            text-align: left;
          }
        }
      }
      .vicp-crop {
        padding-top: 25px;
      }
    }
  }
  .el-button {
    min-width: 80px;
  }
  .vicp-title {
    position: absolute;
    top: -25px;
    font-size: 14px;
    color: $font-c;
    text-align: left;
  }

</style>

<style lang="scss">

  .crop-slider.el-slider {
    width: 160px;
    margin-top: 2.5px;
    margin-left: 20px;
    .el-slider__runway {
      height: 16px;
      margin: 0;
      border-radius: 8px;
    }
    .el-slider__button-wrapper {
      top: -10px;
    }
    .el-slider__bar {
      height: 16px;
      border-radius: 8px;
    }
  }
</style>
